import React from "react";
import { Polyline, Polygon, Circle, InfoBox } from "@react-google-maps/api";

const GeocercasList = ({
                                   geocercas,
                                   tipoGeocerca,
                                   getGeocercaOptions,
                                   zoom,
                                   geocercasEnMapa
                               }) => {

    return (
        <>
            {geocercas?.map((item) => (
                <React.Fragment key={item.id}>
                    {item.tipo === tipoGeocerca.linea && (
                        <Polyline
                            path={item.puntos}
                            options={getGeocercaOptions(item)}
                        />
                    )}
                    {item.tipo === tipoGeocerca.poligono && (
                        <Polygon
                            paths={item.puntos}
                            options={getGeocercaOptions(item)}
                        />
                    )}
                    {item.tipo === tipoGeocerca.circulo && (
                        <Circle
                            center={item.puntos[0]}
                            radius={item.puntos[0].r}
                            options={getGeocercaOptions(item)}
                        />
                    )}
                    {zoom > 10 && geocercasEnMapa.has(item.id) && geocercasEnMapa.size < 50 && (
                        <InfoBox
                            position={{ lat: item?.lat, lng: item?.lng }}
                            options={{
                                closeBoxURL: ``,
                                enableEventPropagation: true,
                                disableAutoPan: true,
                                pixelOffset: new window.google.maps.Size(-30, -10)
                            }}
                        >
                            <div
                                style={{
                                    fontSize: "1.3em",
                                    color: `black`,
                                    fontWeight: 'bold'
                                }}
                            >
                                {item.nombre}
                            </div>
                        </InfoBox>
                    )}
                </React.Fragment>
            ))}
        </>
    );
};

export default GeocercasList;